module.exports = __webpack_public_path__ + "img/loader-mts.fca1a2d.svg";